export default __webpack_public_path__ + "static/media/ergo.d29cf373.png";